var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowFat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96.299mm",
    height: "82.704mm",
    viewBox: "0 0 96.299 82.704",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55.124 -83.24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90.185,
    cy: 87.065,
    r: 0,
    stroke: "#000",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.654 87.172-30.163 30.47s-4.6516 3.4159-4.3531 7.2968c0.29853 3.8809 5.1282 7.7104 5.1282 7.7104l29.825 29.976s3.6843 4.1361 8.0618 3.174c5.0998-1.1209 5.1872-7.9654 5.1872-7.9654l-0.0578-19.402 39.481-0.0935s3.6446 0.35617 6.3896-2.7436c2.346-2.6492 2.2677-6.1776 2.2677-6.1776l1e-5 -8.8264s0.14661-4.6175-2.1704-7.3713c-2.1949-2.6086-6.8964-2.4438-6.8964-2.4438l-39.032 0.23111 0.0774-21.154s0.0525-4.595-4.3159-6.2706c-4.4818-1.7191-9.4299 3.5896-9.4299 3.5896z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowFat);
export default __webpack_public_path__ + "static/media/LeftArrowFat.b139a33251ab2de6af94ae99995fcce1.svg";
export { ForwardRef as ReactComponent };